import { useEffect, useState } from 'react';
import { axiosInstance } from '../helpers/axios';
import { IArticleCard } from '../types/types';

export const useFetchArticles = (page: number, size: number, rubric = '') => {
    const [articles, setArticles] = useState<IArticleCard[] | null>(null);
    const [pageCount, setPageCount] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        axiosInstance
            .get('/v1/article/', {
                params: { page, size, rubric: rubric || undefined },
            })
            .then((response) => {
                setArticles(response.data.objects);
                setPageCount(response.data.page_count);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => setIsLoading(false));
    }, [page, size, rubric]);

    return { articles, pageCount, isLoading };
};
